import React, { useEffect, useState, Children } from 'react';
import { RoomAssets } from '../components/rooms/RoomAssets';
export function RoomDetail() {
  const [roomData, setRoomData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [roomImages, setRoomImages] = useState<any[]>([{
    id: '1',
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wVQhnbj3swJxvFUYQfTssC/Screenshot_2025-10-01_at_10.57.42_AM.png',
    caption: 'Patio View',
    uploadedBy: 'Simon Verraest',
    uploadDate: '15/08/2025, 13:44',
    isActive: true,
    isFeatured: true
  }]);
  useEffect(() => {
    // In a real application, this would fetch room data from an API
    // For now, we'll just simulate loading data
    const searchParams = new URLSearchParams(window.location.search);
    const roomId = searchParams.get('id');
    // Mock data
    const mockRoomData = {
      id: roomId || '1',
      name: 'Premium Overwater Villa',
      category: 'OVERWATER_VILLA',
      code: 'POWVDTAC',
      description: 'Perched above the crystal-clear lagoon, the Premium Overwater Villa offers uninterrupted views of the Indian Ocean and direct access to the water from a private sun deck. Designed for ultimate relaxation and comfort.',
      isSmoking: false,
      isAccessible: false,
      isActive: true,
      view: 'SEA_VIEW',
      size: '250',
      amenities: ['Wi-Fi', 'TV', 'Minibar', 'Air Conditioning', 'Balcony', 'Terrace', 'Ocean View', 'Private Pool', 'Jacuzzi', 'Slippers', 'Desk', 'Dining Area', 'Interconnecting Rooms', 'Non-Smoking', 'Beach Access', 'Breakfast Included'],
      baseAdultsOccupancy: 2,
      baseChildrenOccupancy: 0,
      maxOccupancy: 2,
      allowAdditionalAdults: false,
      allowAdditionalChildren: false,
      bedConfigurations: [{
        type: 'King',
        count: 1
      }]
    };
    setTimeout(() => {
      setRoomData(mockRoomData);
      setLoading(false);
    }, 500);
  }, []);
  const handleUploadImage = (files: FileList) => {
    // In a real application, this would upload the files to a server
    // For now, we'll just add them to our local state
    const newImages = Array.from(files).map((file, index) => {
      const url = URL.createObjectURL(file);
      return {
        id: `new-${Date.now()}-${index}`,
        url,
        caption: file.name,
        uploadedBy: 'Simon Verraest',
        uploadDate: new Date().toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).replace(',', ''),
        isActive: true,
        isFeatured: false
      };
    });
    setRoomImages([...roomImages, ...newImages]);
  };
  const handleUpdateImage = (imageId: string, updates: any) => {
    setRoomImages(prev => prev.map(img => img.id === imageId ? {
      ...img,
      ...updates
    } : img));
  };
  const handleDeleteImage = (imageId: string) => {
    setRoomImages(prev => prev.filter(img => img.id !== imageId));
  };
  const handleBack = () => {
    window.location.href = '/rooms';
  };
  if (loading) {
    return <div className="flex justify-center items-center h-64" data-id="element-10484">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600" data-id="element-10485"></div>
      </div>;
  }
  return <div data-id="element-10486">
      <RoomAssets roomId={roomData.id} roomName={roomData.name} images={roomImages} onBack={handleBack} onUpload={handleUploadImage} onUpdateImage={handleUpdateImage} onDeleteImage={handleDeleteImage} data-id="element-10487" />
    </div>;
}